import React, { useEffect, useRef, useState } from 'react'
import { ChatPage } from '../chat-page'
import { ChatRoom, CompanyChatOpenInfo, Type, Visitor } from '../types'
import { Form } from '../form'
import { ChatWindowContainer, CloseButton, Company, Head, HeadIcon, NameAndSlogan } from '../chat-page/components'
import { SelectType } from '../select-type'
import { closeChat, useListenFromParent } from '../messaging'
import { messageQueue, trackChatPage } from '../utils'
import { initChat } from '../backend'
import styled from 'styled-components'

const EmptyBody = styled.div`
  flex: auto;
  background-color: #FFFFFF;
`
interface UseChatRoom {
  visitor: Visitor
  show: boolean
}
const useChatRoom = ({ show, visitor }: UseChatRoom) => {
  const [whatDoICallThis, setWhatDoICallThis] = useState(show)
  const [type, setType] = useState<Type>()
  const hasClassifies = !!visitor.classifies?.length
  const selectType = hasClassifies && type === undefined
  const shouldInit = whatDoICallThis && (!hasClassifies || type !== undefined)
  useEffect(() => {
    if (show) {
      setWhatDoICallThis(true)
    }
  }, [show])
  const loading = useRef(false)
  const [chatRoom, setChatRoom] = useState<ChatRoom>()
  useEffect(() => {
    (async () => {
      if (!loading.current && shouldInit) {
        try {
          loading.current = true
          const chatRoom = await initChat(type?.serviceClassifyId)
          trackChatPage(type?.serviceClassifyId)
          setChatRoom(chatRoom)
        } catch (e) {

        } finally {
          loading.current = false
        }
      }
    })()
  }, [shouldInit])
  return { chatRoom, setType, selectType, type, show: whatDoICallThis }
}

export interface ChatProps {
  companyInfo: CompanyChatOpenInfo
  visitor: Visitor
}
export const Chat: React.FC<ChatProps> = ({ companyInfo, visitor }) => {
  const { showChat } = useListenFromParent()
  const [filled, setFilled] = useState(false)
  const { show, chatRoom, selectType, type, setType } = useChatRoom({
    show: showChat,
    visitor
  })
  const fillForm = visitor.preConsultFormId !== null && !filled
  let body: React.ReactNode
  if (!show) {
    body = <EmptyBody />
  } else if (fillForm) {
    body = (
      <Form
        formId={visitor.preConsultFormId!}
        onSuccess={(formData) => {
          setFilled(true)
          messageQueue.push('我提交了一个咨询表单')
          messageQueue.push(JSON.stringify(Object.fromEntries(formData)))
        }}
      />
    )
  } else if (selectType) {
    body = (
      <SelectType
        types={visitor.classifies!}
        onSelect={type => setType(type)}
      />
    )
  } else if (chatRoom) {
    body = (
      <ChatPage
        companyInfo={companyInfo}
        type={type}
        visitor={visitor}
        chatRoom={chatRoom}
      />
    )
  } else {
    body = <EmptyBody />
  }
  return (
    <ChatWindowContainer>
      <Head>
        <HeadIcon />
        <NameAndSlogan>
          <div className="name">{companyInfo.companyName}</div>
          <div className="slogan">{companyInfo.slogan}</div>
        </NameAndSlogan>
        <CloseButton onClick={() => closeChat()} />
      </Head>
      {body}
      <Company/>
    </ChatWindowContainer>
  )
}
